(function () {
    'use strict';

    angular.module("imApp").factory("materialRegisterService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 2214,
                    parameters: parms || {}
                });
            },
            listProcesses: function (parms) {
                return $ihttp.post({
                    method: 29,
                    parameters: parms || {}
                });
            },
            listLastRegisteredMaterials: function (parms) {
                return $ihttp.post({
                    method: 959,
                    parameters: parms || {}
                });
            },
            scanObj: function (edit) {
                return $ihttp.post({
                    method: 2216,
                    parameters: edit
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 150,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
